import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconZoomOutComponent } from "./med-icon-zoom-out.component";

@NgModule({
  declarations: [
    MedIconZoomOutComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconZoomOutComponent,
  ],
})
export class MedIconZoomOutModule { }
